// extracted by mini-css-extract-plugin
var _1 = "_productApprovalTableStyles-module__action-button";
var _2 = "_productApprovalTableStyles-module__action-button-container";
var _3 = "_productApprovalTableStyles-module__approve";
var _4 = "_productApprovalTableStyles-module__button-container";
var _5 = "_productApprovalTableStyles-module__danger";
var _6 = "_productApprovalTableStyles-module__discount-type-date";
var _7 = "_productApprovalTableStyles-module__discount-type-text";
var _8 = "_productApprovalTableStyles-module__gold-row";
var _9 = "_productApprovalTableStyles-module__reject";
var _a = "_productApprovalTableStyles-module__title";
export { _1 as "action-button", _2 as "action-button-container", _3 as "approve", _4 as "button-container", _5 as "danger", _6 as "discount-type-date", _7 as "discount-type-text", _8 as "gold-row", _9 as "reject", _a as "title" }
